// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import React from "react";
import { SvgIcon } from "@mui/material";

const BackSettingsIcon = () => (
  <SvgIcon viewBox="0 0 10.847 6.572">
    <g transform="translate(-84.793 -81.193)">
      <line
        x2="9.64"
        transform="translate(85.5 84.5)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1"
      />
      <line
        y1="2.558"
        x2="2.645"
        transform="translate(85.5 81.9)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1"
      />
      <line
        x2="2.645"
        y2="2.558"
        transform="translate(85.5 84.5)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);

export default BackSettingsIcon;
